module.exports = __webpack_public_path__ + "img/marker.40f13791.png";